import React from 'react';
import '../template-file-css/document-file-template.css';


export const AJC_SrcTransportationServices = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='AJC_SrcTransportationServices' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>I, <input type="text" id="txtParentName" name="txtParentName" className='add-only w-200 d-inline' /> give A JOURNEY FOR CHANGE, LLC </p>
                <p className='w-750'>permission to transport me in a company vehicle or a staff's personal vehicle.</p> 
                <p className='w-750'>I understand that this is a courtesy offered by A JOURNEY FOR CHANGE, LLC. as part of its treatment services and programs. Furthermore, I understand that my consent to this transportation is voluntary and I recognize that I am not obligated to accept this transportation service.
                                    I hereby release A JOURNEY FOR CHANGE, LLC., as well as its staff, clinicians, and Board of Trustees from any claims, rights, demands, causes of action, suits, liabilities, damages or other obligations of any kid whatsoever known or unknown, which may arise from the provision of transportation services. I understand that the A JOURNEY FOR CHANGE, LLC. Transportation Policy requires that staff operating a vehicle have taken precautions prior to consenting to transport clients.
                </p> 
                <p className='w-750'>The following rules must be followed by all passengers in order that this service can be offered: 
                  <ol>
                    <li>Seat belts must be worn at all times.</li>
                    <li>No smoking, eating or drinking allowed in the car.</li>
                    <li>Passengers should behave courteously and in no way be distracting the driver. </li>
                  </ol>
                </p>
            </div>
        </form>

    )
}

              
                
          
